import React, { useState, useEffect } from 'react';
import { USERS } from './config';
import emailjs from '@emailjs/browser';
import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue, set, push, update } from "firebase/database";

// Firebase Setup
const firebaseConfig = {
  apiKey: "AIzaSyDiWkNW0iQY_u-s0538ZdDJI6zUtIMd9tc",
  authDomain: "materialorder-d891c.firebaseapp.com",
  databaseURL: "https://materialorder-d891c-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "materialorder-d891c",
  storageBucket: "materialorder-d891c.firebasestorage.app",
  messagingSenderId: "849774638049",
  appId: "1:849774638049:web:524008d7b781888401d8a0"
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

const CATS = ["Alle", "Sanitär", "Boden/Wand/Decke", "Sonstiges"];

// Markdown Parser
const parseMarkdown = (text) => {
  if (!text) return "";
  let html = text
    .replace(/^# (.*$)/gim, '<h3 style="color:var(--p); margin-bottom:10px;">$1</h3>')
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/__(.*?)__/g, '<u>$1</u>')
    .replace(/\n/g, '<br />');
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

const getStyles = (isDark, isMobileMenuOpen) => `
:root {
  --p: #2563eb; --bg: ${isDark ? '#0f172a' : '#f4f7fa'};
  --card: ${isDark ? '#1e293b' : '#ffffff'};
  --t: ${isDark ? '#f8fafc' : '#1e293b'};
  --sb: ${isDark ? '#020617' : '#0f172a'};
  --border: ${isDark ? '#334155' : '#e2e8f0'};
  --input: ${isDark ? '#1e293b' : '#ffffff'};
}
* { box-sizing: border-box; transition: all 0.2s ease; font-family: 'Inter', sans-serif; }
body { margin: 0; background: var(--bg); color: var(--t); height: 100vh; overflow: hidden; }
.app-layout { display: flex; height: 100vh; width: 100vw; overflow: hidden; position: relative; }

.sidebar { 
  width: 280px; background: var(--sb); color: white; display: flex; flex-direction: column; padding: 30px 20px; flex-shrink: 0; 
  position: relative; z-index: 100;
}

@media (max-width: 768px) {
  .sidebar {
    position: absolute;
    left: ${isMobileMenuOpen ? '0' : '-280px'};
    top: 0;
    bottom: 0;
    transition: left 0.3s ease;
    box-shadow: 10px 0 30px rgba(0,0,0,0.5);
  }
  .floating-cart { width: calc(100% - 40px) !important; left: 20px; right: 20px; }
}

.nav-btn { padding: 14px 18px; border-radius: 14px; color: #94a3b8; cursor: pointer; border:none; background:none; width:100%; text-align:left; font-weight:700; margin-bottom:5px; position:relative; }
.nav-btn.active { background: var(--p); color: white; }
.badge { position: absolute; top: 12px; right: 15px; width: 10px; height: 10px; background: #ef4444; border-radius: 50%; border: 2px solid var(--sb); }

.scroll-box { flex: 1; padding: 25px; overflow-y: auto; -webkit-overflow-scrolling: touch; padding-bottom: 180px; }
.cat-bar { display: flex; gap: 10px; margin-bottom: 25px; overflow-x: auto; padding-bottom: 10px; -webkit-overflow-scrolling: touch; }
.cat-chip { padding: 8px 18px; border-radius: 50px; background: var(--card); border: 1px solid var(--border); cursor: pointer; font-size: 0.85rem; font-weight: 600; white-space: nowrap; }
.cat-chip.active { background: var(--p); color: white; border-color: var(--p); }

.product-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 15px; }
.product-card { background: var(--card); padding: 20px; border-radius: 25px; border: 1px solid var(--border); display: flex; flex-direction: column; height: 100%; text-align: center; }
.add-btn { margin-top: auto; width: 100%; padding: 12px; background: var(--p); color: white; border: none; border-radius: 12px; font-weight: 800; cursor: pointer; }

.login-input, .admin-select { width: 100%; padding: 14px; border-radius: 12px; border: 1.5px solid var(--border); background: var(--input); color: var(--t); margin-bottom: 10px; outline: none; }
.login-btn { width: 100%; padding: 16px; background: var(--p); color: white; border: none; border-radius: 14px; font-weight: 800; cursor: pointer; }

.floating-cart { position: fixed; bottom: 25px; right: 25px; width: 380px; background: var(--card); border: 2px solid var(--p); border-radius: 30px; padding: 25px; box-shadow: 0 20px 60px rgba(0,0,0,0.4); z-index: 5000; }
.qty-ctrl { display: flex; align-items: center; gap: 8px; background: var(--bg); border-radius: 10px; padding: 4px 8px; }
.qty-btn { border: none; background: none; cursor: pointer; font-weight: 900; color: var(--p); padding: 5px 10px; }

.center-container { position: fixed; inset: 0; display: flex; align-items: center; justify-content: center; background: rgba(0,0,0,0.5); backdrop-filter: blur(8px); z-index: 9000; padding: 20px; overflow-y: auto; }
.embed-card { background: var(--card); width: 100%; max-width: 450px; padding: 30px; border-radius: 35px; box-shadow: 0 25px 50px rgba(0,0,0,0.2); text-align: center; border: 1px solid var(--border); margin: auto; }

.sidebar-footer { margin-top: auto; padding-top: 20px; border-top: 1px solid rgba(255,255,255,0.1); }
.copyright { font-size: 0.65rem; color: #64748b; line-height: 1.4; }

.menu-toggle { display: none; background: none; border: none; font-size: 1.5rem; cursor: pointer; padding: 10px; color: var(--t); }
@media (max-width: 768px) { .menu-toggle { display: block; } }

.overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 90; display: ${isMobileMenuOpen ? 'block' : 'none'}; }
`;

export default function App() {
  const [user, setUser] = useState(null);
  const [view, setView] = useState('shop');
  const [isDark, setIsDark] = useState(false);
  const [inventory, setInventory] = useState([]);
  const [history, setHistory] = useState([]);
  const [announcements, setAnnouncements] = useState([]);
  const [hasNewInfo, setHasNewInfo] = useState(false);
  const [cart, setCart] = useState([]);
  const [projectName, setProjectName] = useState('');
  const [activeCat, setActiveCat] = useState("Alle");
  const [toast, setToast] = useState(null);
  const [showTutorial, setShowTutorial] = useState(false);
  const [tutStep, setTutStep] = useState(0);
  const [showPw, setShowPw] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  const triggerToast = (msg) => { setToast(msg); setTimeout(() => setToast(null), 2000); };

  useEffect(() => {
    onValue(ref(db, 'inventory'), (s) => s.val() && setInventory(s.val()));
    onValue(ref(db, 'history'), (s) => s.val() && setHistory(Object.values(s.val()).reverse()));
    onValue(ref(db, 'announcements'), (s) => {
        const data = s.val() ? Object.values(s.val()).reverse() : [];
        setAnnouncements(data);
        if (data.length > 0 && data[0].timestamp > (localStorage.getItem('lastRead') || 0)) setHasNewInfo(true);
    });
  }, []);

  const getStockNum = (str) => parseFloat(str) || 0;

  const handleOrder = async (isPlus = false, plusData = null) => {
    if (!projectName) return alert("Baustelle fehlt!");
    try {
      const datum = new Date().toLocaleString('de-DE');
      let emailText = `👤 BENUTZER: ${user.email}\n📍 ORT: ${projectName}\n══════════════════════\n`;

      if (isPlus) {
        emailText += `🚀 PLUS BESTELLUNG: ${plusData.qty}x ${plusData.name}`;
      } else {
        emailText += `🛒 ARTIKEL:\n` + cart.map(c => {
          const item = inventory.find(i => i.id === c.id);
          const currentStock = getStockNum(item.stock);
          const newStock = currentStock - c.qty;
          return `• ${c.name} (${c.id}) (x${c.qty}) ${newStock <= 0 ? "⚠️ (Z.Z. NICHT VERFÜGBAR)" : ""}`;
        }).join('\n');
      }

      triggerToast("⏳ Bestellung wird gesendet...");
      await emailjs.send('service_dy03d7a', 'template_8clfozb', { from_name: user.email, message: emailText, project: projectName }, 'zF6MX7-KhcOqCiybE');

      if (!isPlus) {
        const updatedInv = inventory.map(item => {
          const cartItem = cart.find(c => c.id === item.id);
          if (cartItem) {
            const num = getStockNum(item.stock);
            const unit = String(item.stock).replace(/[0-9.,-]/g, '').trim();
            return { ...item, stock: `${num - cartItem.qty}${unit ? ' ' + unit : ''}` };
          }
          return item;
        });
        set(ref(db, 'inventory'), updatedInv);
        setCart([]);
      }
      
      push(ref(db, 'history'), { date: datum, user: user.email, project: projectName, content: isPlus ? `${plusData.qty}x ${plusData.name}` : cart.map(c=>`${c.qty}x ${c.name} (${c.id})`).join(', '), type: isPlus ? 'PLUS' : 'LAGER' });
      triggerToast("✅ Bestellung erfolgreich!");
      if(isPlus) setView('shop');
    } catch (e) { alert("Fehler!"); }
  };

  const saveEdit = () => {
    const updatedInv = inventory.map(item => item.id === editingItem.id ? editingItem : item);
    set(ref(db, 'inventory'), updatedInv);
    setEditingItem(null);
    triggerToast("Änderungen gespeichert!");
  };

  if (!user) return (
    <div className="center-container">
      <style>{getStyles(isDark, false)}</style>
      <div className="embed-card">
        <h1 style={{fontSize:'3.5rem', fontWeight:900, marginBottom:10}}>PLUS<span style={{color:'var(--p)'}}>.</span></h1>
        <form onSubmit={e => { 
          e.preventDefault(); 
          const match = USERS.find(u => u.email === e.target.em.value && String(u.password) === e.target.pw.value); 
          if (match) { setUser(match); setShowTutorial(true); } else alert("Login fehlgeschlagen."); 
        }}>
          <input name="em" className="login-input" placeholder="E-Mail" required />
          <div style={{position:'relative'}}>
            <input name="pw" type={showPw ? "text" : "password"} className="login-input" placeholder="Passwort" required />
            <span onClick={()=>setShowPw(!showPw)} style={{position:'absolute', right:15, top:12, cursor:'pointer'}}>{showPw?'👁️':'🙈'}</span>
          </div>
          <button className="login-btn">LOGIN</button>
        </form>
        <p style={{fontSize:'0.7rem', color:'#64748b', marginTop:20, textAlign:'left'}}><b>Admin-Hinweis:</b> Leon Halupczok verwaltet dieses System. Alle Bestellungen werden protokolliert.</p>
      </div>
    </div>
  );

  return (
    <div className="app-layout">
      <style>{getStyles(isDark, isMobileMenuOpen)}</style>
      
      <div className="overlay" onClick={() => setIsMobileMenuOpen(false)}></div>

      {editingItem && (
        <div className="center-container">
          <div className="embed-card">
            <h3>✏️ Artikel bearbeiten</h3>
            <p style={{fontSize: '0.8rem', opacity: 0.6}}>ID: {editingItem.id}</p>
            <input 
              className="login-input" 
              value={editingItem.name} 
              onChange={e => setEditingItem({...editingItem, name: e.target.value})} 
              placeholder="Name"
            />
            <select 
              className="admin-select" 
              value={editingItem.category} 
              onChange={e => setEditingItem({...editingItem, category: e.target.value})}
            >
              {CATS.filter(c => c !== "Alle").map(c => <option key={c} value={c}>{c}</option>)}
            </select>
            <button className="login-btn" onClick={saveEdit}>SPEICHERN</button>
            <button style={{marginTop: 10, background: 'none', border: 'none', color: '#64748b', fontWeight: 700}} onClick={() => setEditingItem(null)}>Abbrechen</button>
          </div>
        </div>
      )}

      {showTutorial && (
        <div className="center-container">
          <div className="embed-card">
            <h2 style={{color:'var(--p)', fontWeight:900}}>{["Willkommen!", "Stammlager", "Information", "Support"][tutStep]}</h2>
            <p style={{marginTop:15, opacity:0.8}}>{["Materialverwaltung leicht gemacht.", "Filter nach Kategorien und bestelle mit einem Klick.", "Klick auf das Info-Icon für Updates (Markdown aktiv).", "Fragen? materialorder.support@gmail.com"][tutStep]}</p>
            <button className="login-btn" style={{marginTop:30}} onClick={()=>tutStep < 3 ? setTutStep(tutStep+1) : setShowTutorial(false)}>{tutStep < 3 ? "Weiter" : "Los geht's!"}</button>
          </div>
        </div>
      )}

      {view === 'plus' && (
        <div className="center-container">
            <div className="embed-card">
                <h2 style={{fontWeight:900}}>⭐ BestellPlus+</h2>
                <input className="login-input" id="p-baustelle" placeholder="Baustelle / Ort" value={projectName} onChange={e=>setProjectName(e.target.value)} />
                <input className="login-input" id="p-name" placeholder="Was wird benötigt?" />
                <input className="login-input" id="p-qty" type="number" placeholder="Menge" />
                <button className="login-btn" onClick={() => handleOrder(true, { name: document.getElementById('p-name').value, qty: document.getElementById('p-qty').value })}>JETZT BESTELLEN</button>
                <button onClick={()=>setView('shop')} style={{marginTop:15, background:'none', border:'none', color:'#64748b', fontWeight:700}}>Abbrechen</button>
            </div>
        </div>
      )}
      
      <aside className="sidebar">
        <div style={{fontSize:'2.2rem', fontWeight:900, marginBottom:40}}>PLUS<span>.</span></div>
        <nav style={{flex:1}}>
          <button className={`nav-btn ${view==='shop'?'active':''}`} onClick={()=>{setView('shop'); setIsMobileMenuOpen(false);}}>📦 Stammlager</button>
          <button className={`nav-btn ${view==='plus'?'active':''}`} onClick={()=>{setView('plus'); setIsMobileMenuOpen(false);}}>⭐ BestellPlus</button>
          <button className={`nav-btn ${view==='info'?'active':''}`} onClick={()=>{setView('info'); setHasNewInfo(false); localStorage.setItem('lastRead', Date.now()); setIsMobileMenuOpen(false);}}>ℹ️ Information {hasNewInfo && <span className="badge" />}</button>
          {user.role === 'admin' && (
            <>
              <button className={`nav-btn ${view==='admin'?'active':''}`} onClick={()=>{setView('admin'); setIsMobileMenuOpen(false);}}>🛡️ Admin</button>
              <button className={`nav-btn ${view==='history'?'active':''}`} onClick={()=>{setView('history'); setIsMobileMenuOpen(false);}}>📜 Verlauf</button>
            </>
          )}
          <button className={`nav-btn ${view==='credits'?'active':''}`} onClick={()=>{setView('credits'); setIsMobileMenuOpen(false);}}>💎 Credits</button>
        </nav>
        
        <div className="sidebar-footer">
          <button onClick={()=>window.location.reload()} style={{color:'#ef4444', border:'1px solid #ef4444', borderRadius:10, padding:8, background:'none', cursor:'pointer', fontWeight:700, width:'100%', marginBottom:15}}>ABMELDEN</button>
          <div className="copyright">
            <b>© 2026 Erwin Projects</b><br/>
            Admin: Leon Halupczok
          </div>
        </div>
      </aside>

      <main style={{flex:1, display:'flex', flexDirection:'column', width: '100%'}}>
        <header style={{ padding: '15px 20px', background: 'var(--card)', display:'flex', alignItems:'center', borderBottom:'1px solid var(--border)' }}>
          <button className="menu-toggle" onClick={() => setIsMobileMenuOpen(true)}>☰</button>
          <b style={{fontSize:'0.85rem', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:'150px'}}>{user.email}</b>
          <button onClick={()=>setIsDark(!isDark)} style={{marginLeft:'auto', background:'none', border:'none', fontSize:'1.2rem', cursor:'pointer'}}>{isDark?'☀️':'🌙'}</button>
        </header>

        <div className="scroll-box">
          {view === 'shop' && (
            <>
              <div className="cat-bar">
                {CATS.map(c => (
                  <div key={c} className={`cat-chip ${activeCat===c?'active':''}`} onClick={()=>setActiveCat(c)}>{c}</div>
                ))}
              </div>
              <div className="product-grid">
                {inventory.filter(i => activeCat === "Alle" || i.category === activeCat).map(item => {
                  const stock = getStockNum(item.stock);
                  return (
                    <div key={item.id} className="product-card">
                      <small style={{color:'var(--p)', fontWeight:800}}>{item.id}</small>
                      <h4 style={{margin:'10px 0', minHeight:'40px', fontSize:'0.9rem'}}>{item.name}</h4>
                      <div style={{fontSize:'0.75rem', marginBottom:15, fontWeight:700, color: stock <= 0 ? '#ef4444' : 'inherit'}}>
                        {stock <= 0 ? "⚠️ z.Z. Nicht verfügbar!" : `Lager: ${item.stock}`}
                      </div>
                      <button className="add-btn" onClick={() => {
                        const ex = cart.find(c => c.id === item.id);
                        if(ex) setCart(cart.map(c => c.id === item.id ? {...c, qty: c.qty+1} : c));
                        else setCart([...cart, {...item, qty: 1}]);
                        triggerToast(`${item.name} +1`);
                      }}>Hinzufügen</button>
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {view === 'info' && (
            <div style={{maxWidth:650, margin:'0 auto'}}>
              <h2 style={{fontWeight:900, marginBottom:25}}>Neuigkeiten & Updates</h2>
              {announcements.map((a, i) => (
                <div key={i} style={{background:'var(--card)', padding:25, borderRadius:25, marginBottom:20, border:'1px solid var(--border)', borderLeft:'6px solid var(--p)'}}>
                  <small style={{opacity:0.5}}>{a.date}</small>
                  <div style={{marginTop:10}}>{parseMarkdown(a.text)}</div>
                </div>
              ))}
            </div>
          )}

          {view === 'admin' && (
            <div style={{maxWidth:800, margin:'0 auto'}}>
              <h2>🛡️ Administration</h2>
              <div style={{background:'var(--card)', padding:25, borderRadius:25, border:'1px solid var(--border)', marginBottom:30}}>
                <h3>📢 News schreiben</h3>
                <textarea id="news-txt" className="login-input" style={{height:100}} placeholder="# Überschrift\n**Fett**\n__Unterstrichen__"></textarea>
                <button className="login-btn" onClick={()=>{
                  const val = document.getElementById('news-txt').value;
                  if(!val) return;
                  push(ref(db, 'announcements'), { text: val, timestamp: Date.now(), date: new Date().toLocaleString() });
                  document.getElementById('news-txt').value = "";
                  triggerToast("News gepostet!");
                }}>POSTEN</button>
              </div>

              <div style={{background:'var(--card)', padding:25, borderRadius:25, border:'1px solid var(--border)', marginBottom:30}}>
                <h3>➕ Neuer Artikel</h3>
                <input id="n-id" className="login-input" placeholder="ID" />
                <input id="n-name" className="login-input" placeholder="Name" />
                <select id="n-cat" className="admin-select">
                  {CATS.filter(c=>c!=="Alle").map(c=><option key={c} value={c}>{c}</option>)}
                </select>
                <input id="n-stock" className="login-input" placeholder="Startbestand" />
                <button className="login-btn" onClick={()=>{
                  const i = document.getElementById('n-id').value, n = document.getElementById('n-name').value, c = document.getElementById('n-cat').value, s = document.getElementById('n-stock').value;
                  if(!i || !n) return;
                  set(ref(db, 'inventory'), [...inventory, {id:i, name:n, category:c, stock:s}]);
                  triggerToast("Artikel hinzugefügt!");
                }}>ARTIKEL SPEICHERN</button>
              </div>

              {inventory.map(item => (
                <div key={item.id} style={{background:'var(--card)', padding:15, borderRadius:20, marginBottom:10, display:'flex', justifyContent:'space-between', alignItems:'center', border:'1px solid var(--border)'}}>
                  <div style={{display:'flex', alignItems:'center', gap:10}}>
                    <button 
                      onClick={() => setEditingItem(item)} 
                      style={{background:'none', border:'none', cursor:'pointer', fontSize:'1.1rem'}}
                    >✏️</button>
                    <span style={{fontSize:'0.85rem'}}><b>{item.name}</b> <small>({item.id})</small></span>
                  </div>
                  <div className="qty-ctrl">
                    <button className="qty-btn" onClick={()=>{
                        const updated = inventory.map(x => {
                            if(x.id === item.id) {
                                const num = getStockNum(x.stock);
                                const unit = String(x.stock).replace(/[0-9.,-]/g, '').trim();
                                return {...x, stock: `${num - 1}${unit}`};
                            } return x;
                        }); set(ref(db, 'inventory'), updated);
                    }}>-</button>
                    <b style={{fontSize:'0.8rem'}}>{item.stock}</b>
                    <button className="qty-btn" onClick={()=>{
                        const updated = inventory.map(x => {
                            if(x.id === item.id) {
                                const num = getStockNum(x.stock);
                                const unit = String(x.stock).replace(/[0-9.,-]/g, '').trim();
                                return {...x, stock: `${num + 1}${unit}`};
                            } return x;
                        }); set(ref(db, 'inventory'), updated);
                    }}>+</button>
                    <button onClick={()=>{if(window.confirm('Löschen?')) set(ref(db, 'inventory'), inventory.filter(x=>x.id!==item.id))}} style={{marginLeft:10, background:'none', border:'none'}}>🗑️</button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {view === 'history' && (
            <div style={{maxWidth:700, margin:'0 auto'}}>
              <h2>📜 Verlauf</h2>
              {history.map((h, i) => (
                <div key={i} style={{background:'var(--card)', padding:15, borderRadius:18, marginBottom:10, border:'1px solid var(--border)'}}>
                  <div style={{display:'flex', justifyContent:'space-between'}}><b style={{color:'var(--p)'}}>{h.type}</b><small>{h.date}</small></div>
                  <div style={{fontWeight:800}}>📍 {h.project}</div>
                  <div style={{fontSize:'0.85rem'}}>{h.content}</div>
                </div>
              ))}
            </div>
          )}

          {view === 'credits' && (
            <div className="center-container" style={{position:'relative', background:'none', backdropFilter:'none'}}>
              <div className="embed-card">
                  <h1 style={{fontSize:'3rem'}}>💎</h1>
                  <h2 style={{fontWeight:900, color:'var(--p)'}}>PLUS SYSTEM</h2>
                  <div style={{marginTop:20}}><b>Programmierung:</b><br/>Leon, Til & Jakob</div>
                  <div style={{marginTop:10}}><b>Design:</b><br/>Leon & Til</div>
                  <div style={{marginTop:25, fontSize:'0.85rem', padding:'15px', background:'rgba(37, 99, 235, 0.1)', borderRadius:'15px'}}>
                    <b>Support & Fehler:</b><br/>
                    <a href="mailto:materialorder.support@gmail.com" style={{color:'var(--p)', textDecoration:'none', fontWeight:700}}>materialorder.support@gmail.com</a>
                  </div>
              </div>
            </div>
          )}
        </div>

        {cart.length > 0 && view === 'shop' && (
          <div className="floating-cart">
            <div style={{display:'flex', justifyContent:'space-between', marginBottom:15}}>
              <b>🛒 Warenkorb ({cart.length})</b>
              <button onClick={()=>setCart([])} style={{background:'none', border:'none', color:'#ef4444', fontWeight:700}}>Leeren</button>
            </div>
            <div style={{maxHeight:120, overflowY:'auto', marginBottom:15}}>
              {cart.map(c => (
                <div key={c.id} style={{display:'flex', justifyContent:'space-between', alignItems:'center', padding:'8px 0', borderBottom:'1px solid var(--border)'}}>
                  <span style={{fontSize:'0.85rem'}}>{c.name} <small>({c.id})</small></span>
                  <div className="qty-ctrl">
                    <button className="qty-btn" onClick={()=>{const n=[...cart]; n.find(x=>x.id===c.id).qty--; setCart(n.filter(x=>x.qty>0))}}>-</button>
                    <b>{c.qty}</b>
                    <button className="qty-btn" onClick={()=>{const n=[...cart]; n.find(x=>x.id===c.id).qty++; setCart(n)}}>+</button>
                  </div>
                </div>
              ))}
            </div>
            <input className="login-input" placeholder="📍 Baustelle..." value={projectName} onChange={e=>setProjectName(e.target.value)} />
            <button className="login-btn" onClick={() => handleOrder(false)}>JETZT BESTELLEN</button>
          </div>
        )}
      </main>
      {toast && <div style={{position:'fixed', top:20, left:'50%', transform:'translateX(-50%)', background:'var(--p)', color:'white', padding:'12px 25px', borderRadius:50, zIndex:10000, fontWeight:700, fontSize:'0.9rem', width:'max-content'}}>{toast}</div>}
    </div>
  );
}